import React, { Fragment } from 'react';

const Picture = ({
    src,
    webpSrc,
    mobileSrc,
    alt,
    className,
    desktop,
    mobile,
    noWebp,
    fetchPriority,
    width,
    height,
    style,
    loading,
    onLoad,
    srcSet,
    sizes,
    decoding,
    ...imgProps
}) => {
    // Detect external URLs - if src starts with http:// or https://, it's external
    const isExternal = src && (src.startsWith('http://') || src.startsWith('https://'));
    // Skip WebP for external URLs or when noWebp prop is explicitly set
    const shouldSkipWebp = noWebp || isExternal;

    const extension = src.split('.').pop();
    const isSvg = extension.toLowerCase() === 'svg';
    const webpSource = webpSrc || src.replace(`.${extension}`, '.webp');
    const desktopClass = desktop ? 'desktop-only' : '';
    const mobileClass = mobile ? 'mobile-only' : '';
    const loadingValue = loading || (fetchPriority ? "eager" : "lazy");

    // Common img props to pass through
    const commonImgProps = {
        className: `${className} ${desktopClass} ${mobileClass}`,
        src: `${src}`,
        alt: `${alt}`,
        loading: loadingValue,
        width,
        height,
        style,
        onLoad,
        srcSet,
        sizes,
        decoding,
        fetchpriority: fetchPriority, // DOM attribute is lowercase
        ...imgProps
    };

    // For SVG files, just return a simple img tag without picture/source elements
    if (isSvg) {
        return <img {...commonImgProps} />;
    }

    return (
        <picture>
            {mobileSrc && (
                <Fragment>
                    {!shouldSkipWebp && (
                        <source
                            srcSet={`${webpSource}, ${mobileSrc.replace(`.${extension}`, '.webp')} 2x`}
                            media="(max-width: 990px)"
                            type="image/webp"
                        />
                    )}
                    <source
                        srcSet={`${src}, ${mobileSrc} 2x`}
                        media="(max-width: 990px)"
                        type={`image/${extension}`}
                    />
                </Fragment>
            )}
            {!shouldSkipWebp && (
                <source srcSet={`${webpSource}`} type="image/webp" />
            )}
            <img {...commonImgProps} />
        </picture>
    );
};

export default Picture;



// WEBPACK FOOTER //
// /usr/src/site-blog/src/components/Picture.jsx